import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button, FormGroup, TextField } from "@mui/material";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import ModuleFieldsMultiSelect from "../../multi-select";
import Select from "../../select"; // Assuming you have a Select component like this
import SelectV2 from "../../select-v2"; // Assuming you have a Select component like this
import { get, put } from "../../../utils/api";
import { startCase } from "lodash";
import ModuleFieldsKeyValueSelect from "../../keyvalue-select";
import ModuleFieldsKeyValueSelectV2 from "../../keyvalue-select-v2";
import FileInput from "../../file-input-edit";
import MultiSelectV2 from "../../multi-select-v2";

interface Field {
  properties: any;
  _id: string;
  key: string;
  type: string;
  ui_element_type: string;
  mapped_collection?: any;
  required: boolean;
}

interface FormData {
  [key: string]: any;
}

export default function EditModule(props: any) {
  const { id } = useParams<{ id: string }>();
  let primary_id = id;
  console.log(props);
  if (!id) {
    primary_id = props.id;
  }
  const navigate = useNavigate();
  const { module, primary_key, modulePath } = props; // Destructuring props for better readability
  const [formData, setFormData] = useState<FormData>({});
  const [fields, setFields] = useState<Field[]>([]);
  const [defaultCountry, setDefaultCountry] = useState<string>("in"); // Default to 'us' in case country detection fails

  useEffect(() => {
    fetchModuleData();
  }, [module, id]); // Added module and id as dependencies for re-fetching data on change

  const fetchModuleData = async () => {
    try {
      const fieldsResponse = await get(`${module}`, {});
      setFields(fieldsResponse.data.fields || []); // Set fields to an empty array if response is undefined
      console.log("fieldsResponse", fieldsResponse.data)

      const dataResponse = await get(`${module}/details`, {
        [primary_key]: primary_id,
      });
      console.log("dataResponse", dataResponse.data)
      setFormData(dataResponse.data || {}); // Set formData to an empty object if response is undefined
    } catch (error) {
      console.error("Error loading data:", error);
      setFields([]); // Set fallback states to handle errors
      setFormData({});
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePhoneChange = (value: string, name: string) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFilesChange = (files: any[], fieldKey: string) => {
    setFormData((prev) => ({ ...prev, [fieldKey]: files }));
    console.log("files-fieldkey", files, fieldKey);
  };

  //   const handleFilesChange = (newFiles: any[], fieldKey: string) => {
  //     setFormData((prev) => {
  //         // Combine previous files with the new files
  //         const updatedFiles = [...(prev[fieldKey] || []), ...newFiles];

  //         return {
  //             ...prev,
  //             [fieldKey]: updatedFiles, // Update the field key with the combined files
  //         };
  //     });

  //     console.log("Updated files for field:", fieldKey);
  // };


  const handleMultiSelectChange = (selectedOptions: any, fieldName: string) => {
    setFormData({
      ...formData,
      [fieldName]: selectedOptions.map((option: any) => option.value),
    });
  };

  const handleSelectChange = (selectedOption: any, fieldName: string) => {
    setFormData({
      ...formData,
      [fieldName]: selectedOption || {}, // Default to an empty object if undefined
    });
    console.log("setFormData selectedOption", selectedOption, fieldName);
    console.log("formData", formData);
  };

  const handleKeyValueSelectChange = (
    selectedOptions: any,
    fieldName: string
  ) => {
    console.log("Selected Options:", selectedOptions);
    console.log("Field Name:", fieldName);
    setFormData({ ...formData, [fieldName]: selectedOptions });
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    console.log("formData", formData);
    try {
      console.log("final_data***", formData);
      await put(`${module}/${id}`, formData);
      // navigate(`${modulePath}/list`);
      navigate(`/${props.module}/list`);

    } catch (error) {
      console.error("Failed to update data:", error);
    }
  };

  const isEmailField = (key: string) => key.toLowerCase().includes("email");
  const isPhoneNumberField = (key: string) =>
    key.toLowerCase().includes("phone") ||
    key.toLowerCase().includes("whatsapp");
    console.log("isEmailField", isEmailField);
  return (
    <div
      className="container"
      style={{ marginTop: "22px", paddingLeft: "20px" }}
    >
      <div className="row new-client-header">
        <div className="col-xs-12">
          <h5>{"Edit " + startCase(module)}</h5>
        </div>
      </div>
      <form onSubmit={handleSubmit}>
        {fields
          .filter((field: any) => field.edit_status) // Ensure create_status exists and is true
          .map((field:any) => (
            <div key={field.key} className="row mt-3 mb-3">
              <div className="col-xs-12 col-md-4 col-lg-4 d-flex align-items-center">
                <label htmlFor={field.key}>
                  {startCase(field.key.replace(/_/g, " "))}
                </label>
              </div>
              <div className="col-xs-12 col-md-8 col-lg-8">
                <FormGroup>
                  {isEmailField(field.key) ? (
                    <TextField
                      sx={{ width: "100%" }}
                      fullWidth
                      type="email" // Set type to email
                      name={field.key}
                      value={formData[field.key] || ""}
                      onChange={handleChange}
                      placeholder={startCase(field.key.replaceAll("_", " "))}
                      required={field.required || false}
                    />
                  ) : isPhoneNumberField(field.key) ? (
                    <PhoneInput
                      country={defaultCountry} // Set the detected country code
                      value={formData[field.key] || ""}
                      onChange={(value: string) =>
                        handlePhoneChange(value, field.key)
                      }
                      inputStyle={{ width: "100%", borderRadius: "4px" }} // Enhance the UI with rounded borders
                      buttonStyle={{ borderRadius: "4px" }}
                      enableSearch={true} // Add country search functionality
                    />
                  ) : field.type === "String" ? (
                    <TextField
                      sx={{ width: "100%" }}
                      fullWidth
                      name={field.key}
                      value={formData[field.key] || ""}
                      onChange={handleChange}
                      placeholder={startCase(field.key.replaceAll("_", " "))}
                      required={field.required || false}
                    />
                  ) : field.type === "Number" ? (
                    <TextField
                      sx={{ width: "100%" }}
                      fullWidth
                      type="number"
                      name={field.key}
                      value={formData[field.key] || ""}
                      onChange={handleChange}
                      placeholder={startCase(field.key.replaceAll("_", " "))}
                      required={field.required || false}
                    />
                  ) : field.type === "Date" ? (
                    <TextField
                      sx={{ width: "100%" }}
                      fullWidth
                      type="date"
                      name={field.key}
                      value={formData[field.key] || ""}
                      onChange={handleChange}
                      required={field.required || false}
                    />
                  ) : field.type === "Object" &&
                    field.ui_element_type == "file-input" ? (
                    <FileInput
                      module={module}
                      primary_id={id}
                      onFileChange={(files: any[]) =>
                        handleFilesChange(files, field.key)
                      }
                      FilesData={formData[field.key] || []} // Ensure default value as an array
                    />
                  ) : field.type === "Object" &&
                    field.ui_element_type == "multi-select" ? (
                    <MultiSelectV2
                      properties={field.properties}
                      formData={formData}
                      values={formData[field.key] || []} // Use existing value or fallback to an empty array
                      onChange={(selectedOptions: any) =>
                        handleSelectChange(selectedOptions, field.key)
                      }
                    />
                  ) : // <></>
                    field.type === "Object" &&
                      field.ui_element_type == "select" ? (
                      <SelectV2
                        properties={field.properties}
                        formData={formData}
                        value={formData[field.key] || []} // Use existing value or fallback to an empty array
                        onChange={(selectedOptions: any) =>
                          handleSelectChange(selectedOptions, field.key)
                        }
                      />
                    ) : // <></>
                      field.type === "Object" &&
                        field.ui_element_type == "key-value-select-v2" ? (
                        <ModuleFieldsKeyValueSelectV2
                          formData={formData}
                          properties={field.properties}
                          values={formData[field.key] || []} // Use existing value or fallback to an empty array
                          onChange={(selectedOptions) =>
                            handleKeyValueSelectChange(selectedOptions, field.key)
                          }
                        />
                      ) : field.type === "Object" &&
                        field.ui_element_type == "key-value-select" ? (
                        <ModuleFieldsKeyValueSelect
                          properties={field.properties}
                          values={formData[field.key] || []} // Use existing value or fallback to an empty array
                          onChange={(selectedOptions) =>
                            handleKeyValueSelectChange(selectedOptions, field.key)
                          }
                        />
                      ) : field.type === "Object" &&
                        field.mapped_collection &&
                        !field.mapped_collection.multiple ? (
                        <Select
                          mapped_collection={field.mapped_collection}
                          value={formData[field.key] || []} // Use existing value or fallback to an empty array
                          onChange={(selectedOptions: any) =>
                            handleSelectChange(selectedOptions, field.key)
                          }
                        />
                      ) : field.type === "Object" && field.mapped_collection ? (
                        <ModuleFieldsMultiSelect
                          mapped_collection={field.mapped_collection}
                          values={formData[field.key] || []} // Use existing value or fallback to an empty array
                          onChange={(selectedOptions: any) =>
                            handleSelectChange(selectedOptions, field.key)
                          }
                        />
                      ) : null}
                </FormGroup>
              </div>
            </div>
          ))}
        <div className="d-flex justify-content-end">
          <Button
            variant="contained"
            type="submit"
            style={{ marginBottom: "50px" }}
          >
            Update
          </Button>
        </div>
      </form>
    </div>
  );
}
